import React from 'react';
import PropTypes, {
  bool, shape, func, string, number
} from 'prop-types';
import { Row, Col } from '@thd-olt-component-react/grid';
import { Fulfillment } from '@thd-olt-component-react/fulfillment';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { TrackOutOfStock } from '@thd-olt-component-react/email-signup';
import { BuyboxActions } from './BuyboxActions';
import * as helper from '../../BuyboxHelper';
import '../buybox.scss';
import { isMobile } from '../../util';

const BuyboxLite = ({
  itemId,
  configurableItems,
  unavailable,
  storeId,
  isOutOfStockOnline,
  isShowATC,
  covidAlert,
  storeZip,
  isATCDisabled,
  channel,
  zipCode,
  fulfillmentMethod,
  fulfillment,
  availabilityType,
  paypalEligible,
  onFulfillmentChange,
  onDeliveryOptionsZipCodeChange,
  onATCClick,
  bopisHolidayTiming,
  hideInstantCheckout,
  hidePaypalCheckout,
  directData,
  isTwoTileEnabledFS,
  quantityLimit
}) => {
  if (isMobile(channel)) {
    const shippingTemplate = helper.renderShippingFulfillment({ fulfillment, availabilityType });
    return (
      <Row data-component="BuyboxLiteMobile">
        <Col fallback="12" className="buybox-wrapper">
          {shippingTemplate.showATC && (
            <div className="buybox__atc--wrapper">
              <AddToCart
                cartOptions={helper.getCartOptions({
                  configurableItems,
                  channel,
                  fulfillmentMethod: shippingTemplate.method,
                  alterBrowserHistory: true
                })}
                cartReqParams={helper.getCartReqParams({
                  itemId,
                  configurableItems,
                  storeZip,
                  fulfillmentMethod: shippingTemplate.method,
                  quantity: 1,
                  zipCode,
                  storeId,
                  fulfillment
                })}
                onClick={onATCClick}
                disabled={isATCDisabled}
              >
                Add to Cart
              </AddToCart>
            </div>
          )}
          <div className={`${shippingTemplate.oos ? '' : 'fulfillment--lite'}`}>
            {shippingTemplate.template}
          </div>
          {shippingTemplate.oos && (
            <TrackOutOfStock itemId={itemId} />
          )}
        </Col>
      </Row>
    );
  }

  return (
    <Row data-component="BuyboxLite">
      <Col fallback="12" className="buybox-wrapper">
        <div className="buybox-wrapper__lite">
          <div className="buybox-top__wrapper">
            {!unavailable && (
              <div className="buybox__fulfillment-wrapper">
                <div className="buybox__fulfillment">
                  <Fulfillment
                    itemId={itemId}
                    covidAlert={covidAlert}
                    onChange={onFulfillmentChange}
                    onDeliveryZipCodeChange={onDeliveryOptionsZipCodeChange}
                    bopisHolidayTiming={bopisHolidayTiming}
                    directData={directData}
                    isBuyBoxLite
                    isTwoTileEnabledFS={isTwoTileEnabledFS}
                  />
                </div>
              </div>
            )}
          </div>
          {isShowATC && (
            <div className="buybox__actions">
              <BuyboxActions
                alterBrowserHistory
                itemId={itemId}
                storeId={storeId}
                storeZip={storeZip}
                disableATC={isATCDisabled}
                channel={channel}
                zipCode={zipCode}
                fulfillmentMethod={fulfillmentMethod}
                fulfillment={fulfillment}
                paypalEligible={paypalEligible}
                onATCClick={onATCClick}
                hideQuantity
                hideInstantCheckout={hideInstantCheckout}
                hidePaypalCheckout={hidePaypalCheckout}
                isTwoTileEnabledFS={isTwoTileEnabledFS}
                quantityLimit={quantityLimit}
              />
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
};

BuyboxLite.propTypes = {
  itemId: string,
  unavailable: bool,
  covidAlert: bool,
  bopisHolidayTiming: number,
  storeId: string,
  isOutOfStockOnline: bool,
  isShowATC: bool,
  storeZip: string,
  isATCDisabled: bool,
  channel: string,
  zipCode: string,
  configurableItems: shape({
    itemId: string,
    isAnchor: bool
  }),
  fulfillmentMethod: string,
  fulfillment: shape({
    backordered: bool
  }),
  availabilityType: shape({
    discontinued: bool,
    status: bool,
    buyable: bool,
    type: string
  }),
  paypalEligible: bool,
  onFulfillmentChange: func,
  onDeliveryOptionsZipCodeChange: func,
  onATCClick: func,
  hideInstantCheckout: bool,
  hidePaypalCheckout: bool,
  /* eslint-disable-next-line react/forbid-prop-types */
  directData: PropTypes.objectOf(PropTypes.any),
  isTwoTileEnabledFS: bool,
  quantityLimit: number
};

BuyboxLite.defaultProps = {
  itemId: null,
  configurableItems: null,
  unavailable: false,
  storeId: null,
  isOutOfStockOnline: false,
  isShowATC: true,
  covidAlert: false,
  storeZip: null,
  isATCDisabled: false,
  channel: 'desktop',
  zipCode: null,
  fulfillmentMethod: null,
  fulfillment: null,
  availabilityType: null,
  paypalEligible: false,
  onFulfillmentChange: () => {},
  onDeliveryOptionsZipCodeChange: () => {},
  onATCClick: () => {},
  bopisHolidayTiming: null,
  hideInstantCheckout: false,
  hidePaypalCheckout: false,
  directData: null,
  isTwoTileEnabledFS: false,
  quantityLimit: 0
};

export { BuyboxLite };
